import React from "react";

const Head = () => {
  return (
    <header className=" py-4 ">
      <div className="container position-relative top-50 px-lg-5">
        <div className="text-center  text-white">
          <h1 className="display-4 fw-bolder">Shop in style</h1>
          <p className="lead fw-normal text-white-50 mb-0">
            Trend & Fashion changes, but style endures.
          </p>
          <button type="button" className="btn btn-primary text-light my-4">
            Learn more
          </button>
        </div>
      </div>
    </header>
  );
};
export default Head;
